import * as React from 'react';
import { Layout } from 'react-admin';
import GestifyAppBar from './GestifyAppBar';

const GestifyLayout = (props) => <Layout {...props} appBar={GestifyAppBar} />;

export default GestifyLayout;